import LinkVocabularyWrapper from './LinkVocabularyWrapper';

export default LinkVocabularyWrapper;
